import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useAgents() {

    const agents = useSelector<RootState, RootState["agents"]>(
        ({ agents }) => agents
    )

    return agents
}
